import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Heart } from 'lucide-react';
export const CommunitySection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const translateY = useTransform(scrollYProgress, [0, 1], [0, -50]);
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section id="community" ref={sectionRef} className="py-20 md:py-28 bg-black relative overflow-hidden" style={{
    opacity
  }} data-id="element-954" data-mp="3tsbebb5rr3sd">
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-amber-950/20 to-black" data-id="element-955" data-mp="3ovb72wx6nuzo"></div>
      <motion.div className="container mx-auto px-4 relative z-10" style={{
      y: translateY
    }} data-id="element-956" data-mp="3krd9wrrf4u99">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-957" data-mp="29cpuhuvz1zlf">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-958" data-mp="3a8flrh6snb0g">
            Cultural Preservation
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-959" data-mp="3ecez5qws1tpl">
            COMMUNITY
            <br data-id="element-960" data-mp="30hcqiw0jpq93" />
            <span className="text-amber-400" data-id="element-961" data-mp="359mbryqpu251">& CAUSE</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-962" data-mp="35bp9l4y40zkb"></div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto font-light" data-id="element-963" data-mp="2qmkrrov88xcq">
            This isn't just entertainment — it's preservation, pride, and seva.
          </p>
        </motion.div>
        {/* ROM Heritage Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-20 max-w-4xl mx-auto" data-id="element-964" data-mp="2hmnw33af6y86">
          <div className="border-2 border-amber-400/40 p-8 md:p-12 bg-gradient-to-br from-amber-950/20 to-black/60" data-id="element-965" data-mp="ie64zowjn7k1">
            <div className="text-center mb-8" data-id="element-966" data-mp="edm88mfvu5yf">
              <h3 className="font-serif text-3xl md:text-4xl text-amber-400 mb-4" data-id="element-967" data-mp="1b1saj2pc0m9j">
                Building on a Legacy
              </h3>
              <div className="w-16 h-px bg-amber-400/30 mx-auto" data-id="element-968" data-mp="1648qfm5ydf9o"></div>
            </div>
            <div className="max-w-3xl mx-auto" data-id="element-969" data-mp="120aqxacpu2g3">
              <p className="text-white/80 text-lg leading-relaxed mb-6 font-light text-center" data-id="element-970" data-mp="1236p8zsh6t52">
                This immersive experience honors the groundbreaking "Art of the
                Sikh Kingdoms" exhibition at the Royal Ontario Museum in August
                2000—the second most popular exhibition in ROM history.
              </p>
              <p className="text-white/70 leading-relaxed font-light text-center" data-id="element-971" data-mp="1xbifvzrpeio3">
                Where that exhibition brought artifacts behind glass, we bring
                the entire kingdom to life around you—transforming scholarship
                into sensation, and history into an unforgettable evening.
              </p>
            </div>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-972" data-mp="2g1qgaa40qv0l">
          <p className="text-amber-400 font-light text-sm tracking-[0.3em] uppercase mb-6" data-id="element-973" data-mp="2tym10ztmuawh">
            Proudly Presented By
          </p>
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-lg p-8 inline-block" data-id="element-974" data-mp="zm5oxie5o2jp">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/48U2qmRQoErrPvLaJoyvZa/akalsteellogo1.png" alt="Akal Steel Logo" className="w-40 h-auto object-contain" data-id="element-975" data-mp="9c4xaq6yzmxs" />
          </motion.div>
          <p className="text-white font-light text-lg mt-6 tracking-wider" data-id="element-976" data-mp="3rgyj166ecq1h">
            Akal Steel (2005) Inc.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center max-w-3xl mx-auto mt-24" data-id="element-977" data-mp="3mox9vt4izffo">
          <p className="text-2xl text-amber-400 font-light italic" data-id="element-978" data-mp="1eba61oci2kjw">
            "Every ticket funds cultural storytelling + community uplift."
          </p>
        </motion.div>
      </motion.div>
    </motion.section>;
};